module.exports = __webpack_public_path__ + "static/media/share_screen.2be90bee.svg";